// import { Message } from 'element-ui'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { getNoAuthQuickList } from '@/api/quck_bi'

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/login', '/auth-redirect', '/forgetpw'] // no redirect whitelist
// const shareMenuPaths = {
// 	// 公共资源菜单路径
// 	driverDetailNew: { key: 'driver_detail' }, // 司机详情
// 	order_detail: { key: 'order_detail' }, // 订单详情
// 	workOrder_detail: { key: 'work_order_detail' }, // 工单详情
// 	notOrder_workOrder_detail: { key: 'work_order_detail' }, // 工单详情(内部工单无订单)
// }
// 将query中的参数重新拼回url
const joinQueryString = (query) => {
  const keys = Object.keys(query);
  let result = '';

  keys.forEach((key, index) => {
      if (key === 'redirect') {
          return;
      }
      result += `&${key}=${query[key]}`;
  });

  return result;
}

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	// set page title
	document.title = getPageTitle(to.meta.title)

	// determine whether the user has logged in
	const hasToken = getToken()

	if (hasToken) {
		const hasMenus = store.getters.roles && store.getters.roles.length > 0
		if (to.path === '/login') {
			// if is logged in, redirect to the home page
			next({ path: '/' })
			NProgress.done()
		} else {
      if (hasMenus) {
				// 路由拦截判断是否有公共页面权限（司机详情、工单详情、订单详情等）
				// for (let path in shareMenuPaths) {
				// 	// 跳转到公共页面时，判断是否有权限，没有权限则提示
				// 	if (to.path.includes(path) && !store.getters.shareMenuButtons[shareMenuPaths[path].key]) {
				// 		Message.error('您没有权限访问该页面!')
				// 		if (from.path === '/login') {
				// 			// 判断场景：处在公共页面时，退出登录后此时下掉此账号该公共页面权限，重新登录重定向判断无权限后定位到首页
				// 			next({ path: '/home' })
				// 		} else {
				// 			next(false)
				// 			return
				// 		}
				// 	}
				// }
				let is_open_new_page = store?.state?.tagsView?.cachedViews?.some(item => {
					if (item == to?.name) {
						return true
					}
				})
				if (to.path.includes('driver-train') || to.path.includes('travelSys')) {
					store.dispatch('driverTraining/getDriverTrainingEnumInfo')
					next()
				}
				if (is_open_new_page || to.name == 'Home') {
					next()
				} else {
					if (localStorage.getItem('user_selection') == '1') {
						if (to.path == from.path || from.path == '/') {
							next()
						} else {
							if (location.hash?.split('#')[1] == from.path) {
								next({ name: from.name })
								document.title = getPageTitle(from.meta.title)
							}
							let routeUrl = router.resolve({
								path: to.path,
								query: to.query,
								fullPath: to.fullPath,
							})
							window.open(routeUrl.href)
						}
					} else {
						next()
					}
				}
			} else {
				try {
          // get user info
          const response = await store.dispatch('user/getInfo')
          let quickBiList = []
          if (process.env.NODE_ENV == 'production') {
            const quickBiRes =  await getNoAuthQuickList()
            quickBiList = quickBiRes?.data?.list ?? []
          }
					if (response?.code === 10000) {
						const { data } = response
						const [...menus] = data?.menu
						// generate accessible routes map based on roles
						const accessRoutes = await store.dispatch('permission/generateRoutes', { menu: menus, quickBiList })
						// dynamically add accessible routes
						router.addRoutes(accessRoutes)
					}
					// hack method to ensure that addRoutes is complete
					// set the replace: true, so the navigation will not leave a history record
          if (from?.query?.redirect) {
            const fullPath = `${from?.query?.redirect}${joinQueryString(from?.query)}`
            next(fullPath)
          } else {
            next({ ...to, replace: true })
          }
				} catch (error) {
          // 密码有效期3个月后需要修改密码，其他接口会报10103，跳转到修改密码页，之后获取quick_bi菜单接口getNoAuthQuickList报错触发catch逻辑会重新跳转到登录页，因此注释以下代码
					// await store.dispatch('user/resetToken')
					// next(`/login?redirect=${to.fullPath}`)
					// NProgress.done()
				}
			}
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next()
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			next(`/login?redirect=${to.fullPath}`)
			NProgress.done()
		}
	}
})

router.afterEach(async (to, from) => {
	if (from.meta.id) {
		to.meta.metaId = from.meta.id
		window.localStorage.setItem('metaId', from.meta.id)
	}
	const { id = 0 } = to.meta
	const { meta_id = 0, metaId = 0, redirect = ''} = to.query
  const localMetaId = window.localStorage.getItem('metaId')
	// 不是登录页且需要重定向，根据菜单ID获取按钮权限
  const params_id = id || meta_id || metaId || localMetaId

  // 登录页和忘记密码页不需要获取按钮权限
  const buttonAuthWhiteList = ['/login', '/forgetpw']
  if (!redirect && params_id && !buttonAuthWhiteList.includes(to.path)) {
		console.log(`[V2 路由] 📋 跳转到路由 ${to.path}, 菜单ID: ${params_id}`)
		await store.dispatch('permission/getPermissionButton', params_id)
		console.log(`[V2 路由] ✅ 菜单ID ${params_id} 的权限已加载`)
	}
	// finish progress bar
	NProgress.done()
})
